import type { Data } from "shelving";
import { useStore } from "shelving/react";
import { wrapText } from "../util/react.js";
import { useFormContext } from "./Form.js";

/** Helper component that allows fields to be shown/hidden based on the form's current values. */
export function FormCondition<T extends Data>({
	onChange,
	children,
	fallback = null,
}: {
	/** Function that receives the parent form's current values and shows its children only if `true` is returned. */
	onChange: (values: Partial<T>) => boolean;
	/** Children that are shown if the condition is met. */
	children: React.ReactNode;
	fallback?: React.ReactNode;
}): React.ReactElement | null {
	const { data } = useStore(useFormContext<T>());
	return onChange(data) ? <>{children}</> : wrapText(fallback, <aside className="notice notice-error" />);
}
